import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { getFullUrl } from 'hubspot-url-utils';
import { getIsQAProxy } from '../utils/proxyUtils';
export const getBusinessObjectives = ({
  highlightedProducts,
  highlightedFeatureType
}) => {
  return noAuthHttp.get(`${getFullUrl('app-api', getIsQAProxy() ? {
    envOverride: 'qa'
  } : {})}/feature/store/v1/business-objectives/by-api-names`, {
    query: {
      productApiNames: highlightedProducts,
      highlightedFeatureType
    }
  });
};